<template>
    <div class="w-full">
        <v-select
            v-model="pickedLocations"
            id="locations"
            :options="locations"
            @search="fetchOptions"
            multiple
            :disabled="disabled ? true : false"
        >
            <template slot="no-options"> Nema lokacija </template>
        </v-select>

        <input
            v-for="loc in pickedLocations"
            :key="loc.value"
            type="hidden"
            name="locations[]"
            :value="loc.value"
        />
    </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
    },

    props: {
        oldLocations: {
            required: false,
        },

        disabled: {
            required: false,
            default: false,
        },
    },

    data() {
        return {
            pickedLocations: null,
            locations: [],
        };
    },

    created() {
        this.fetchOptions("");

        if (this.oldLocations) {
            this.pickedLocations = this.oldLocations;
        }
    },

    methods: {
        fetchOptions(search) {
            axios
                .get(route("admin.api.search.locations", { query: search }))
                .then((response) => {
                    this.locations = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },
};
</script>
